document.addEventListener('click', async function (event) {
    let el = event.target as HTMLFormElement

    if (el.classList.contains('js-standard-lead-submission')) {
        let frmId = el.getAttribute('data-formid')
        let frm 

        if (frmId)
            frm = document.getElementById(frmId) as HTMLFormElement
        else
            frm = document.getElementById('frm-standard-lead-modal') as HTMLFormElement

        if (!frm)
            frm = el.closest('form')

        if (frm) {
            let frmData = new FormData(frm);
            
            const response = await fetch('/?handler=StandardLeadSubmissionForm', {
                method: 'POST', body: frmData
            })
            let jsonData = await response.json()

            frm.innerHTML = jsonData.content

            document.getElementById('sl-modal-button-submit')?.classList.add('hidden')
            document.getElementById('sl-modal-button-cancel')?.classList.add('hidden')
            document.getElementById('sl-modal-button-close')?.classList.remove('hidden')
        }
    }
})